const exercisesList = [
  {
    id: 1,
    name: 'Abdominaux',
    created_at: '2022-08-14T21:36:53.000000Z',
    updated_at: null,
    exercises: [
      {
        id: 1,
        name: 'Relevés de buste',
        description: 'Cet exercice de musculation travaille les abdominaux. Il raffermit la taille et développe la sangle abdominale si on utilise un poids pour lester. Il nécessite un banc incliné dédié aux abdominaux.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 2,
        name: 'Relevés de bassin',
        description: "Cet exercice de musculation travaille les abdominaux et raffermit la \r\n  taille. Il a la réputation de solliciter le bas des abdominaux. A la \r\n  différence d'autres exercices, celui-ci ne permet pas rajouter du lest, \r\n  mais il n'en reste pas moins efficace.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 3,
        name: 'Le développé Pallof',
        description: 'Et non, il ne s’agit pas d’un exercice pour la poitrine ou les \r\n  épaules. Cette fois-ci, ce sont les abdominaux qui s’y collent ! \r\n  Cet exercice qui porte le nom du physiothérapeute John Pallof a \r\n  l’air au premier abord assez facile. Mais détrompez-vous, il est plus \r\n  difficile qu’il n’y parait !',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 4,
        name: 'Rotation du buste à la poulie',
        description: "Voici un exercice d'isolation que je pratique régulièrement à la fin de \r\n\tma séance d'abdominaux. Il est utile pour renforcer la taille, plus \r\n\tparticulièrement les obliques, sur le côté, et se fait en unilateral. Il a \r\n\tla réputation de réduire le tour de taille et d'aider à faire partir \r\n\tles poignées d'amour. Mais comme vous le savez, c'est surtout votre diète \r\n\tqui agira sur ces amas graisseux… Avec une charge convenable, vous allez \r\n\tsentir vos obliques travailler, croyez-moi ! ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 5,
        name: 'Gainage des obliques avec le Side bridge',
        description: 'La plupart d’entre nous pensent que les exercices d’abdominaux dynamiques comme les crunchs ou les relevés de bassin sont les meilleurs exercices pour les abdominaux. Les  exercices de gainage  sont souvent délaissés au profit de ces exercices populaires.\r\n\tCependant, il ne faut pas sous-estimer ces exercices, notamment le Side Bridge – et ses variantes – qui pourraient bien vous réserver quelques surprises.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 8,
        name: 'Flexions latérales du buste au banc',
        description: "Les flexions latérales du buste au banc composent un exercice efficace pour travailler les muscles de la taille, afin de muscler ou d'affiner et raffermir cette dernière. C'est un mouvement simple qui demande peu de matériel mais qui doit être exécuté correctement pour éviter les blessures.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 9,
        name: 'Torsion de bassin couché',
        description: 'Cet exercice de musculation affine et raffermit la taille. Il développe les obliques situés sur le côté de la taille.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 10,
        name: 'Sit-up',
        description: 'Cet exercice de musculation raffermit la taille et muscle les abdominaux. Il a la réputation de travailler le bas du ventre, là où le crunch au sol sollicite plutôt le haut des abdominaux.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 11,
        name: 'Crunch à la poulie haute',
        description: "Le crunch à la corde effectué sur la poulie haute est un exercice très efficace pour travailler la sangle abdominale. Il consiste à enrouler le buste vers l'avant en tirant sur la poulie, ce qui reproduit le mouvement du crunch classique, mais à la verticale. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 12,
        name: 'Crunch au sol',
        description: 'Le crunch est un exercice simple et efficace pour muscler les abdominaux. \r\n\tIl affine et raffermit la taille si vous travaillez avec le poids du corps, \r\n\tet développe les abdominaux si vous utilisez un lest de plus en plus lourd. \r\n\tIl ne nécessite pas de matériel et peut être réalisé n’importe où.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 13,
        name: 'Relevés de jambes en suspension',
        description: 'Cet exercice de musculation travaille les abdominaux et développe les \r\n  obliques grâce à la torsion de bassin sur le côté. Il est assez \r\n  difficile à réaliser en suspension car il faut se maintenir accroché à \r\n  la barre.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 20,
        name: 'Relevés de jambes renversés',
        description: 'Voici un excellent mouvement pour muscler vos abdominaux \r\n  et renforcer votre buste. Les relevés de jambes renversés à la \r\n  barre peuvent être réalisés partout. Pas besoin de machines ou \r\n  d’appareils de musculation compliqués, il suffit d’une barre ou \r\n  d’un support solide à agripper et le tour est joué.\r\n  Cet exercice de musculation \r\n  vous rendra fort. Mais il faut \r\n  avouer qu’il est assez difficile à réaliser surtout si vous êtes \r\n  débutant. Quand j’ai commencé les relevés de jambes renversés, \r\n  je n’arrivais à faire que 4 ou 5 répétitions. Avec \r\n  l’entraînement, j’ai pu monter jusqu’à 20 répétitions \r\n  et mes abdominaux sont durs comme de l’acier.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 21,
        name: 'Flexions du buste à la machine',
        description: "Avoir des abdominaux musclés n'est pas seulement un avantage esthétique, c'est aussi d'une grande importance pour améliorer vos performances dans d'autres exercices de musculation et dans des sports parallèles. Cela permet également de prévenir les problèmes de dos. C'est pourquoi il existe de nombreux exercices pour travailler les abdominaux et, parmi eux, les flexions du buste à la machine. Cette dernière est équipée d'un dossier et de poignées qui aident à effectuer le mouvement correctement. Il est aussi possible d'ajouter du poids à l'exercice.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 22,
        name: 'La planche',
        description: "Le gainage face au sol, aussi appelé « planche » est un exercice isométrique, c'est-à-dire qu'il se pratique de façon statique. Le but est de maintenir une position pendant un certain temps en utilisant les muscles posturaux pour verrouiller les articulations. C'est un exercice surtout utilisé pour renforcer les muscles profonds de l'abdomen, \r\n\tobtenir un ventre plus plat et réduire les risques de blessure d'un entraînement classique.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 23,
        name: 'Relevés de jambes',
        description: 'Cet exercice de musculation exécuté sur un banc incliné raffermit les abdominaux et la taille. Il travaille à la fois les abdominaux et les fléchisseurs de la hanche.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 24,
        name: 'Roue abdominale',
        description: "La roue abdominale est un accessoire peu onéreux qui permet d'effectuer des mouvements très efficaces pour muscler les abdominaux, améliorer la posture et la stabilité du corps, si l'on sait comment bien l'utiliser. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 94,
        name: 'Relevés de genoux',
        description: 'Cet exercice de musculation des abdominaux est souvent réalisé sur une chaise \r\n  romaine, un appareil qu’on trouve dans la plupart des salles de musculation. \r\n  Il raffermit et muscle la taille, les abdominaux mais aussi les \r\n  fléchisseurs de la hanche.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 95,
        name: 'Crunchs avec rotation',
        description: 'Cet exercice de musculation affine et raffermit la taille si vous \r\n  travaillez sans haltère. Il développe les obliques si vous utilisez un \r\n  lest de plus en plus lourd.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
      {
        id: 96,
        name: 'Flexions Latérales',
        description: 'Cet exercice de musculation affine et raffermit la taille si vous travaillez sans charge. Il développe les obliques situés sur sur le côté de la taille, si vous utilisez des poids de plus en plus lourds.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 1,
      },
    ],
  },
  {
    id: 2,
    name: 'Pectoraux',
    created_at: '2022-08-14T21:36:53.000000Z',
    updated_at: null,
    exercises: [
      {
        id: 25,
        name: 'Développé couché aux haltères',
        description: "Le développé couché est un exercice de base pour cibler les pectoraux. Il peut s'exécuter avec une barre ou sur machine. Mais, avec des haltères, il possède l’intérêt de permettre un mouvement plus naturel, une meilleure contraction des pectoraux et un plus grand étirement des muscles. C'est un exercice qui fait appel aux muscles stabilisateurs et qui n'est pas aussi facile à maîtriser que le développé couché à la barre. En effet, le corps doit d'abord s'habituer à trouver l'équilibre. Parce que la stabilisation rajoute de la difficulté, il n'est pas possible de soulever aussi lourd qu'avec une barre.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 28,
        name: 'Développé décliné',
        description: "Cet exercice de musculation de base sollicite plutôt les parties moyennes \r\n  et inférieures des pectoraux. Il permet de gagner de la force en plus de \r\n  galber la poitrine. On peut le réaliser sur un banc à la barre (avec un \r\n  partenaire) ou avec des haltères qui permettent plus d'amplitude. C'est un \r\n  exercice qui demande de la pratique pour être maîtrisé.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 33,
        name: 'Ecarté couché incliné',
        description: "Cet exercice de musculation est un exercice d'isolation qui permet \r\n  de travailler la partie supérieure des \r\n  pectoraux \r\n  (partie claviculaire). Il minimise l'intervention \r\n  des épaules (deltoïde antérieur) \r\n  et ne sollicite quasi pas les\r\n  triceps.\r\n  Généralement, cet exercice de musculation est placé à la fin de la séance de \r\n  pectoraux comme mouvement de finition après les exercices lourds pour la masse.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 38,
        name: 'Les dips façon Gironda',
        description: "Vince Gironda est un culturiste des années 50, considéré à \r\n  l’époque comme l'un des meilleurs entraîneurs de bodybuilding. Surnommé le « Iron \r\n  Guru », il a entrainé et porté à la victoire de nombreux \r\n  athlètes, dont le plus connu est Larry Scott.\r\n  De nombreuses stars du bodybuilding se sont entrainées dans son \r\n  gymnase comme Lou Ferrigno « l’incroyable Hulk », Frank Zane \r\n  et même Arnold Schwarzenegger.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 46,
        name: 'Développé à la machine convergente',
        description: "Voici une machine guidée que j'apprécie beaucoup et qui m'a \r\n  permis d'améliorer mes pectoraux, surtout la partie interne et \r\n  supérieure. A force de faire du \r\n  développé couché et des \r\n  dips, les \r\n  parties sternale et supérieure des pectoraux peuvent présenter un \r\n  retard difficile à combler. La 'Hammer Strength', une machine \r\n  convergente servant à faire des développés en position assise \r\n  peut vous aider dans cette tache.\r\n  S'entrainer sur ce type de machine est un vrai plaisir ! On \r\n  développe la charge au dessus de la poitrine en effectuant un \r\n  mouvement en arc de cercle qui rapproche les poignets l'une de \r\n  l'autre. L'exercice guidé permet de travailler en toute sécurité \r\n  sur un parcours plus naturel que les machines habituelles. On ne \r\n  ressent pas d'inconfort articulaire comme c'est souvent le cas \r\n  avec des développés sur la Smith machine. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 54,
        name: 'Dips',
        description: "Les répulsions aux barres parallèles ou « Dips » est un exercice de \r\n  musculation de base qui permet de travailler \r\n  l'ensemble du buste. Les dips sont très efficaces et de formidables bâtisseuses de muscles.\r\n  Si cet exercice est trop difficile voir impossible \r\n  à réaliser, vous pouvez débuter par les dips entre deux bancs. Un fois \r\n  l'exercice maîtrisé, passez aux barres parallèles avec le poids du \r\n  corps. Plus tard, vous pourrez même accrocher un lest autour de la \r\n  taille pour ajouter encore de la difficulté à l'exercice.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 55,
        name: 'Pull-over',
        description: "Cet exercice de musculation est souvent placé dans la séance de \r\n  pectoraux. Pourtant, si on touche le grand pectoral pendant l'exécution, \r\n  on se rend compte qu'il est plutôt décontracté alors que le grand dorsal \r\n  (muscle du dos) est sous tension. Le pull-over sollicite donc plutôt le \r\n  dos.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 57,
        name: 'Poulie vis-à-vis',
        description: "Cet exercice de musculation est un exercice d'isolation pour les \r\n  pectoraux. Pour le faire, on utilise une machine avec deux poulies hautes reliées à \r\n  deux poignées. L'intervention de l'épaule dans le mouvement est réduite \r\n  et celle des triceps quasi nulle.\r\n  Généralement, cet exercice de finition est utilisé pour congestionner \r\n  les pectoraux en fin de séance.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 69,
        name: 'Développé couché prise inversée',
        description: "Le développé couché prise inversée est une variante du développé couché classique, qui se pratique avec les mains en supination plutôt qu'en pronation. C'est un exercice peu pratiqué mais qui possède l'avantage de mettre l'accent sur la sollicitation du haut des pectoraux, des triceps et de l'avant des épaules. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 71,
        name: 'Développé couché incliné barre',
        description: "Cet exercice de \r\n  musculation est un exercice de base qui permet de travailler la \r\n  poitrine. L'inclinaison du banc fait porter le stress sur la \r\n  partie supérieure des pectoraux mais aussi sur la partie \r\n  antérieure du deltoïde (avant des épaules). Plus le banc sera \r\n  incliné, plus les épaules seront sollicitées.\r\n  L'utilisation des haltères permet de travailler dans une plus \r\n  grand amplitude qu'avec la barre et nécessite plus d'activité au niveau \r\n  des muscles stabilisateurs. Il est conseillé de démarrer votre séance de \r\n  musculation des pectoraux par des exercices inclinés si la partie \r\n  claviculaire (haut des pectoraux) est un point faible.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 74,
        name: 'Pompes au sol',
        description: "Tout le monde à déjà pratiqué cet exercice de musculation au moins une \r\n  fois ! C'est un classique du genre qui permet de travailler l'ensemble \r\n  du buste. On peut se construire de bons pectoraux avec seulement les pompes \r\n  mais à condition de savoir s'y prendre pour bien développer toutes les \r\n  parties de ce groupe musculaire. En effet, selon la position des mains et \r\n  l'inclinaison, on pourra favoriser le haut, le bas ou même l'intérieur des \r\n  pectoraux.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 75,
        name: 'Développé couché incliné aux haltères',
        description: "Le développé couché incliné aux haltères est l'un des exercices de musculation les plus utiles pour développer le haut des pectoraux. Chez la plupart des pratiquants, c'est une zone en retard. La position inclinée est donc une solution pour rééquilibrer la poitrine. L'utilisation des haltères permet alors une position plus naturelle qu'avec une barre, une meilleure contraction, puisqu'il est possible de rapprocher les mains, et un meilleur étirement. Enfin, cela permet de travailler davantage les muscles stabilisateurs.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 79,
        name: 'Développé couché barre',
        description: "Cet exercice de musculation très populaire développe la poitrine. Le développe couché est un \r\n  exercice de base qui fait intervenir deux \r\n  articulations (coude et épaule) et qui permet \r\n  de travailler l'ensemble du buste, pas seulement les \r\n  pectoraux.\r\n  C'est un des mouvement qui permet d'évaluer la force musculaire \r\n  des membres supérieurs et qui est utilisé dans les épreuves de force \r\n  athlétique.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 83,
        name: 'Les pompes Dive Bomber',
        description: 'Beaucoup de choses ont été écrites sur les \r\n  pompes, et vous \r\n  connaissez probablement toutes les variantes de cet exercice \r\n  surtout si vous êtes un adepte des mouvements au poids du corps. \r\n  Les pompes sont un des meilleurs exercices de \r\n  musculation pour remodeler les muscles du buste sans nécessiter \r\n  le moindre matériel.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 84,
        name: 'Ecarté couché haltères',
        description: "Cet exercice de musculation d'isolation permet de travailler les pectoraux. Il minimise l'intervention \r\n  des épaules (deltoïde antérieur) et ne sollicite \r\n  quasi pas les triceps. On \r\n  pourra le placer en fin de séance comme exercice de finition des pectoraux.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 85,
        name: 'Pec-Deck',
        description: "Cet exercice de musculation sollicite les pectoraux. C'est un exercice \r\n  d'isolation qui permet de travailler sur une grande amplitude. Très apprécié \r\n  par les débutants, le « butterfly » finalise généralement la session de \r\n  pectoraux après les mouvements de base. Si vous travaillez en séries assez \r\n  longues, il vous procurera de très bonnes sensations et une congestion \r\n  intense.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 88,
        name: 'Dips entre 2 bancs',
        description: "Cet exercice de musculation est une variante des \r\n\tdips classiques qui s'effectue au poids de corps, entre deux bancs. Il demande beaucoup moins d’équilibre que les dips. Les dips entre 2 bancs permettent de solliciter les triceps, mais aussi les pectoraux et les épaules. De plus, ce mouvement peut être ajusté pour convenir aux débutants. Mais, il est également possible d'en augmenter la difficulté pour les personnes qui possèdent plus de force. Cet exercice est également connu sous le nom de « répulsions entre deux bancs » ou « reverse dips ».",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 90,
        name: 'Développé assis à la machine',
        description: "Le développé assis à la machine ou « presse à pectoraux », est une alternative au développé couché à la barre ou aux haltères, qui présente l'avantage d'être sécurisé et donc de permettre un travail plus lourd. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
      {
        id: 93,
        name: 'Développé couché à la smith machine',
        description: "Le développé couché à la smith machine est une variante du développé couché classique qui se pratique grâce à un cadre guidé. Ce cadre a l'avantage de sécuriser le mouvement et donc de limiter les accidents. Mais, cela permet aussi de mieux se concentrer sur la travail des pectoraux, de se passer de partenaire et de travailler lourd et\/ou à l'échec. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 2,
      },
    ],
  },
  {
    id: 3,
    name: 'Dos',
    created_at: '2022-08-14T21:36:53.000000Z',
    updated_at: null,
    exercises: [
      {
        id: 6,
        name: 'Extensions au banc',
        description: "Cet exercice de musculation renforce les lombaires et sollicite \r\n  indirectement un grand nombre de muscles de muscles de la chaîne \r\n  postérieure. Des lombaires musclés et solides, en plus d'être esthétiques, \r\n  sont très utiles pour de nombreux exercices où les charges peuvent être \r\n  importantes. C'est notamment le cas du squat et du soulevé de terre, mais \r\n  ils participent aussi durant les tirages et certains développés.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 7,
        name: 'Le rowing inversé',
        description: 'Le rowing inversé est un des meilleurs exercices de musculation \r\n  pour le dos, quand il est correctement exécuté. Il permet de \r\n  renforcer le haut du dos, les dorsaux, les arrières d’épaules, \r\n  les biceps et les muscles de la taille en isométrie (gainage).\r\n  En plus de développer la masse musculaire du dos, le rowing \r\n  inversé, pratiqué régulièrement, sera bénéfique pour la posture et \r\n  permettra « d’ouvrir le buste » de ceux qui ont les épaules qui \r\n  partent en avant. ',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 26,
        name: 'Rowing un bras',
        description: 'Cet exercice de musculation sollicite les muscles du dos. L’utilisation du \r\n  banc permet d’éviter le travail des lombaires. Vous pouvez alors plus vous concentrer sur le travail des muscles du dos sans vous \r\n  occuper de son alignement. On peut alors manipuler des charges assez \r\n  importantes.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 27,
        name: 'Tirage prise serrée',
        description: "Cet exercice de musculation sollicite les muscles du dos. Le travail à la \r\n\tpoulie haute est intéressant quand il n'est pas possible de faire des \r\n\ttractions à la barre fixe, avec le poids du corps. On peut facilement régler \r\n\tla charge de départ avec un poids qui correspond à notre niveau de force, et \r\n\tl'augmenter au fur et à mesure des progrès. La prise serrée sollicite \r\n\tsurtout le grand dorsal, le grand rond et bien sûr les biceps.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 29,
        name: 'Rowing barre T',
        description: "Cet exercice de musculation \r\n  sollicite les muscles du dos en épaisseur. Il existe des machines \r\n  spécifiques pour faire du rowing à la barre T, \r\n  mais il est possible de faire l'exercice avec une simple barre droite \r\n  coincée dans un angle. Il suffit d’une barre et de quelques rondelles de fonte \r\n  pour pouvoir le faire.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 30,
        name: 'Tractions à la barre fixe',
        description: "Cet exercice de musculation sollicite et développe les muscles du dos, surtout au niveau de la largeur. \r\n\tLes tractions à la barre fixe sont de formidables bâtisseuses de dorsaux. En \r\n\ttant que mouvement de base, nous vous conseillons de l'inclure dans votre \r\n\troutine de dos. Ceux qui ne peuvent pas faire de tractions avec le poids du \r\n\tcorps pourront se diriger vers les tirages à la poulie haute.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 34,
        name: 'Tractions au sternum Gironda',
        description: 'Après les dips façon Gironda, nous vous \r\n  présentons une façon peu commune de travailler son dos : les \r\n  tractions au sternum ! Cette variante popularisée par Vince Gironda, une des \r\n  personnalités les plus influentes et respectées dans le monde du \r\n  bodybuilding des années 50, implique de garder le torse penché \r\n  en arrière tout le long du mouvement.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 35,
        name: 'Tirage nuque',
        description: 'Cet exercice de musculation sollicite les muscles du dos surtout \r\n  au niveau de la largeur. Le travail à la poulie haute \r\n  permet à ceux qui ne sont pas encore capable de faire des tractions à la \r\n  barre fixe avec leur poids du corps, de muscler leur dos en largeur.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 41,
        name: 'Good Morning barre',
        description: 'Cet exercice de musculation sollicite les lombaires, fessiers et arrières cuisses. Il est peu pratiqué en salle car particulièrement risqué si mal exécuté. On laissera ce mouvement aux pratiquants chevronnés et on lui préfèrera les extensions du buste au banc.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 42,
        name: 'Exercices dos : Tirage barre cuisses',
        description: 'Le tirage barre cuisses est un mouvement d’isolation qui permet, généralement, de « finir » le dos. C’est une variante du pull-over classique avec un haltère dont la position peu stable demande une certaine pratique et empêche l’utilisation de charges trop lourdes. Cependant, avec suffisamment de maîtrise, il est possible d’obtenir une grande congestion du dos.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 45,
        name: 'Tirage sol poulie basse',
        description: "Cet exercice de musculation appelé tirage à la poulie basse ou « tirage \r\n    sol » sollicite les muscles du dos en épaisseur. C'est un très bon \r\n    exercice pour gagner de la masse musculaire sur l'ensemble du dos, notamment \r\n\tla partie supérieure. Si vous manquez de volume dans cette zone, cet \r\n\texercice est fait pour vous et vous aidera à gagner en épaisseur rapidement. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 49,
        name: 'Le Power Clean',
        description: "Comme vous avez pu le constater, je suis toujours à la recherche de nouveaux exercices pour varier un peu Entraînements et \r\n    éviter la routine. Aujourd’hui, nous nous intéressons au Power Clean, une version « bodybuilding » de l'épaulé des haltérophiles.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 68,
        name: 'Le Muscle-Up',
        description: "« Tu ne fais jamais rien comme les autres ! ». Voila ce qu’on m’a sorti en me voyant m’entrainer au Muscle-up. Non, je ne cherche pas à être différent des autres et à attirer l'attention sur moi. Mais après 13 années de musculation, j’ai besoin de me fixer des nouveaux challenges, la plupart de mes objectifs initiaux étant atteints.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 77,
        name: 'Shrug barre',
        description: 'Cet exercice de musculation sollicite et développe les \r\n  trapèzes. \r\n  Ces grands muscles en éventail sont situés sur le haut du dos et \r\n  recouvrent toute la partie supérieure du cou et du dos.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 82,
        name: 'Tirage poitrine',
        description: 'Cet exercice de musculation \r\n  sollicite les muscles du dos au niveau \r\n  de la largeur. Le travail à la poulie haute permet à ceux qui ne sont \r\n  pas encore capables de faire des tractions sur la barre fixe avec le poids \r\n  du corps, d’exercer les dorsaux.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
      {
        id: 89,
        name: 'Rowing barre',
        description: 'Cet exercice de musculation travaille l’ensemble des muscles du dos, plutôt en épaisseur. Il est particulièrement efficace pour gagner de la \r\n  masse et épaissir le dos. La position penchée en avant rend cet exercice \r\n  risqué pour le bas du dos. Les débutants \r\n  en musculation doivent d’abord renforcer les lombaires et les abdominaux \r\n  avant de s’exercer sur cet exercice.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 3,
      },
    ],
  },
  {
    id: 4,
    name: 'Épaules',
    created_at: '2022-08-14T21:36:53.000000Z',
    updated_at: null,
    exercises: [
      {
        id: 31,
        name: 'Élévations latérales buste penché (Oiseau)',
        description: "Cet exercice de musculation sollicite les épaules, plus \r\n    particulièrement le faisceau postérieur situé à l'arrière. C’est un exercice d’isolation \r\n\tidéal pour cibler cette partie du deltoïde souvent en retard par rapport au \r\n\treste. En effet, on a tendance à avoir plus de deltoïdes antérieurs (avant \r\n\tdes épaules) car les exercices qui ont le plus de succès auprès des \r\n\tpratiquants sollicitent beaucoup cette \r\n\tzone : développé couché, \r\n\tdips, développés épaules…",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 37,
        name: 'Les élévations latérales aux câbles',
        description: 'Si vous voulez une carrure athlétique, \r\n  avec des épaules larges et bien rondes, alors il faudra vous \r\n  attarder sur les deltoïdes externes. Ces muscles sont ceux qui \r\n  vous donneront cette largeur tant recherchée par \r\n  les culturistes.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 44,
        name: 'Élévations latérales à la machine',
        description: "Cet exercice est une variante des élévations latérales classiques et demande d'avoir accès à une machine spécifique. Le mouvement se pratique assis et permet de cibler précisément les deltoïdes. Cela apporte une grande efficacité, même s'il est alors plus difficile de lever des charges lourdes, notamment parce qu'il est impossible de tricher en donnant de l'élan. De plus, la machine sécurise les épaules en évitant les oscillations et les mauvais mouvements pour préserver les articulations et les tendons. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 47,
        name: 'Rowing menton',
        description: "Si vous voulez gagner de la largeur d'épaules et épaissir le haut de votre \r\n\tdos, alors le rowing menton devrait vous intéresser ! Cet exercice de musculation \r\n\tappelé qui consiste à faire un tirage vertical avec la barre en l'amenant \r\n\tjusqu'au menton, un « rowing menton », sollicite les muscles des épaules et les trapèzes \r\n\tindirectement.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 48,
        name: 'Développé nuque',
        description: "Cet exercice de musculation sollicite les épaules. Les développés sont des \r\n\tmouvements basiques, très efficaces pour se forger de bonnes épaules. Dans \r\n\tcette variante de développé, on descend la barre verticalement derrière la \r\n\tnuque, jusqu'au niveau des oreilles. L'objectif est de cibler \r\n\tle côté et l'arrière de l'épaule, par rapport au développé par devant qui lui cible plutôt l'avant.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 50,
        name: 'Le Développé Cubain',
        description: 'Aujourd’hui, nous nous intéressons à l’un des meilleurs exercices de \r\n  musculation pour renforcer la stabilité de l’épaule : le \r\n  développé Cubain !',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 62,
        name: 'Elévations latérales',
        description: "Cet exercice de musculation sollicite les épaules, plus \r\n    particulièrement le faisceau latéral, sur le côté, qui donne la fameuse largeur d’épaule \r\n\ttant recherchée. Il est vrai que la carrure est la première chose que l'on \r\n\tremarque quand on croise quelqu'un dans la rue. Larges et bien galbées, de \r\n\tbonnes épaules vous mettent en valeur habillé. Plus besoin de rembourrage ou \r\n\td'épaulettes pour accentuer la carrure de son costume ! Disons-le, des \r\n\tépaules au top, énormes et sèches, ça fait son effet ! Alors mieux vaut \r\n\tmiser sur ce groupe musculaire clé et ne rien laisser au hasard…",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 70,
        name: 'Le développé Arnold',
        description: 'Parmi les meilleurs exercices de musculation pour obtenir des épaules grosses comme des melons, on trouve les classiques développés qu’on peut réaliser à la barre ou aux haltères. Mais peu de gens connaissent le « développé Arnold ». ',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 76,
        name: 'Développé devant',
        description: "Les développés sont parfaits pour se forger des épaules massives. Le \r\n   développé devant renforce les muscles des épaules, surtout l'avant et le \r\n   côté, et indirectement le haut des pectoraux et les triceps. C’est un \r\n   exercice polyarticulaire très complet qui vous donnera plus de gains musculaires \r\n   et de force que les exercices d’isolation comme les élévations frontales ou \r\n   latérales. La version barre devant ou aux haltères sont deux des meilleurs \r\n   exercices pour les épaules, aussi bien pour les débutants que les confirmés.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 87,
        name: 'Face Pull : un 3 en 1 !',
        description: "Le face pull est un exercice qui est peu pratiqué par les pratiquants de musculation. Et pourtant, c'est un mouvement qui possède de nombreux avantages, notamment le fait de solliciter l'arrière des épaules, zone souvent négligée, et le fait de renforcer la coiffe des rotateurs grâce à une rotation externe. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
      {
        id: 110,
        name: 'Développé avec haltères',
        description: "Cet exercice de musculation sollicite les muscles des épaules, et \r\n\tindirectement les triceps – à l'arrière des bras – et le haut des pectoraux. \r\n\tC’est un exercice de base, idéal pour prendre de la masse, de l'épaisseur et construire \r\n\tdes épaules massives.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 4,
      },
    ],
  },
  {
    id: 5,
    name: 'Biceps',
    created_at: '2022-08-14T21:36:53.000000Z',
    updated_at: null,
    exercises: [
      {
        id: 36,
        name: 'Biceps avec le curl Zottman',
        description: 'Pour continuer dans la lignée des exercices de \r\n  musculation \r\n  oubliés, nous nous intéressons aujourd’hui au curl Zottman, une \r\n  variante du curl haltères qui vise les biceps mais aussi les \r\n  avant-bras. George Zottman était un homme fort dans les \r\n  années 1880\/1890, considéré en son temps comme l’homme le plus \r\n  fort des Etats-Unis. Il a établi de nombreux records de force au \r\n  squat,\r\n  soulevé de terre et développé \r\n  un bras, dont certains sont encore de nos jours inégalés.\r\n  Même à 57 ans, il avait des avant-bras \r\n  bien massifs et musclés de près de 42 cm (contractés) si l’on \r\n  se fie aux sources de l’époque.\r\n  Bien que de nombreux athlètes \r\n  aient aujourd’hui oublié l’homme et ses records, il a laissé son \r\n  nom à un des meilleurs exercices pour à la fois matraquer bras \r\n  et avant-bras: le curl Zottman.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 51,
        name: 'Curl prise marteau haltères',
        description: 'Le curl prise marteau avec haltères, ou « Hammer curl », est une variante du curl haltère classique qui s’exécute avec les haltères en prise neutre, aussi appelée prise marteau. C’est un exercice qui cible les biceps, à l’instar des autres variantes du curl, mais qui met aussi l’accent sur les avant-bras. C’est d’ailleurs le meilleur exercice pour solliciter le long supinateur, un muscle qui augmente la taille des avant-bras.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 52,
        name: 'Curl barre',
        description: 'Cet exercice de musculation sollicite et développe les biceps. Le curl \r\n  barre est l’exercice d’isolation de base pour les biceps.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 56,
        name: 'Biceps avec le curl Gironda',
        description: 'Après les dips Gironda et les \r\n  tractions au sternum, nous \r\n  terminons les articles dédiés aux exercices inédits de l’« Iron \r\n  Guru » avec les curls façon Gironda.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 58,
        name: 'Curl haltère',
        description: 'Cet exercice de musculation sollicite et développe les biceps. Les haltères \r\n  permettent pas mal de variantes intéressantes.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 64,
        name: 'Le curl Araignée',
        description: "C'est certain, tout le monde veut des gros bras ! C'est un groupe \r\n  musculaire important quel que soit le niveau du pratiquant de \r\n  musculation. Arnold avait des \r\n  biceps comme des montagnes, et ceux du tout premier Mr Olympia - Larry Scott \r\n  - étaient énormes.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 67,
        name: 'Curl concentration',
        description: "Cet exercice de musculation sollicite et développe les biceps. Le curl en \r\n\tconcentration est un exercice d'isolation qui va vous permettre de peaufiner \r\n\tvos bras. Les curls à la barre ou aux haltères sont les exercices de \r\n\tmusculation de base bien utiles pour développer la massse de vos biceps et \r\n  obtenir des gros bras. Vous devrez donc les privilégier. Ils \r\n  pourront éventuellement être complétés par du curl concentration pour \r\n  diversifier l'entraînement des biceps. Cet exercice à la réputation de \r\n  développer le « pic » du biceps.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 72,
        name: 'Curl pupitre',
        description: 'Cet exercice de musculation sollicite et développe les biceps si vous \r\n  utilisez un lest de plus en plus lourd. Le pupitre permet de plus se \r\n  concentrer sur le muscle et évite de tricher en se balançant.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 80,
        name: 'Le curl Incliné',
        description: "Le Curl Incliné est une variante du \r\n\tcurl classique qui, comme ce dernier, est un exercice d'isolation ciblant principalement le travail des biceps.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 86,
        name: 'Curl pupitre à la machine',
        description: "Ce type de curl est effectué sur une machine, munie d'un pupitre, qu'on nomme aussi pupitre Larry Scott, du nom du célèbre bodybuilder. C'est un exercice d'isolation pour les biceps qui sollicite mieux le brachial que les curls effectués de façon classique. De plus, la machine exerce une tension continue et uniforme durant tout le mouvement et limite la triche, ce qui oblige à conserver une technique propre. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
      {
        id: 91,
        name: 'Curls inversés à la barre',
        description: "Les curls inversés avec la barre, aussi appelés « reverse curls » ou curls en pronation, sont une variante du mouvement de curl classique avec une barre. C'est un mouvement qui permet de renforcer les poignets, les avant-bras et de développer la masse musculaire sur la partie basse du biceps. C'est un exercice que l'on réserve généralement aux pratiquants avancés, car il permet un travail de finition des avant-bras, zone qui est déjà travaillée par d'autres exercices.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 5,
      },
    ],
  },
  {
    id: 6,
    name: 'Triceps',
    created_at: '2022-08-14T21:36:53.000000Z',
    updated_at: null,
    exercises: [
      {
        id: 39,
        name: 'Développé couché prise serrée',
        description: "Le développé couché prise serrée est une variante du développé couché standard qui met l'accent sur les triceps. C'est un des mouvements pour les triceps qui permet de porter les charges les plus lourdes.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 6,
      },
      {
        id: 40,
        name: 'Extensions à la poulie haute',
        description: "Cet exercice de \r\n  musculation développe les triceps si vous utilisez des charges \r\n  de plus en plus lourdes. C'est un exercice d'isolation simple mais pas aussi rentable en terme de gains musculaires que les \r\n  exercices de base comme les \r\n  dips ou les \r\n  développés à la barre.\r\n  Il est généralement conseillé aux débutants du fait de sa \r\n  facilité d'exécution et permet une bonne approche. Les plus chevronnés pourront le placer à la fin de la séance de musculation \r\n  des triceps et utiliser des accessoires variés pour travailler différemment.\r\n  Cet exercice permet d'obtenir une résistance constante pendant \r\n  tout le parcours du mouvement ce qui n'est pas le cas avec des poids \r\n  libres.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 6,
      },
      {
        id: 60,
        name: 'Barre-front',
        description: "Cet exercice de musculation développe la masse et la force des triceps, à \r\n\tl'arrière des bras. Dans le jargon de la musculation, on le surnomme « barre-front \r\n\t» du fait qu'on amène la barre au niveau du front durant la phase négative du mouvement. Il consiste à faire des extensions à la barre droite ou \r\n\tà la barre EZ (plus confortable pour les coudes et les poignets), couché sur un banc ou allongé sur le sol. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 6,
      },
      {
        id: 65,
        name: 'kick back',
        description: "Cet exercice de musculation appelé « kick back » développe les triceps à \r\n  l'arrière du bras. C'est un exercice de finition qu'on place généralement à \r\n  la fin de la séance de triceps pour obtenir une bonne congestion dans ces \r\n  muscles. On ne peut pas prendre très lourd sur cet exerice d'isolation, et \r\n  ce n'est pas le but. L'objectif est de se concentrer sur les sensations \r\n  musculaires. \r\n  Nous vous conseillons de le placer à la fin de votre séance de \r\n  musculation des triceps, après les exercices poly-articulaires \r\n  de base - utilisés pour gagner un maximum de volume aux bras - comme les \r\n  dips\r\n  ou les développés qui plus « rentables ».",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 6,
      },
      {
        id: 92,
        name: 'Extensions au-dessus de la tête',
        description: "Cet exercice de musculation développe les muscles triceps qui se situe \r\n  sur la face postérieure du bras. La position du bras au-dessus de la \r\n  tête rend l'exercice plus difficile par rapport au barre-front ou au \r\n  travail à la poulie haute. La charge utilisée sera donc moins \r\n  importante.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 6,
      },
    ],
  },
  {
    id: 7,
    name: 'Avant-bras',
    created_at: '2022-08-14T21:36:53.000000Z',
    updated_at: null,
    exercises: [
      {
        id: 53,
        name: 'Extensions des poignets à la barre',
        description: "L'extension des poignets à la barre est un exercice d'isolation pur qui sollicite les extenseurs de l'avant-bras dans sa face externe, contrairement aux flexions des poignets qui travaillent, elles, la face interne. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 7,
      },
      {
        id: 59,
        name: 'Flexions des poignets avec haltères',
        description: 'Les flexions des poignets aux haltères sont une variante des flexions des poignets à la barre et représentent un exercice tout à fait efficace pour muscler les avant-bras. ',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 7,
      },
      {
        id: 61,
        name: 'Flexions des poignets avec la barre',
        description: "La flexion des poignets à la barre est le mouvement le plus pratiqué pour travailler les muscles fléchisseurs du poignet qui sont sollicités dans tous les exercices où il est question d'empoigner des haltères ou une barre. C'est dire leur importance. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 7,
      },
      {
        id: 73,
        name: 'Biceps avec le curl Zottman',
        description: 'Pour continuer dans la lignée des exercices de \r\n  musculation \r\n  oubliés, nous nous intéressons aujourd’hui au curl Zottman, une \r\n  variante du curl haltères qui vise les biceps mais aussi les \r\n  avant-bras. George Zottman était un homme fort dans les \r\n  années 1880\/1890, considéré en son temps comme l’homme le plus \r\n  fort des Etats-Unis. Il a établi de nombreux records de force au \r\n  squat,\r\n  soulevé de terre et développé \r\n  un bras, dont certains sont encore de nos jours inégalés.\r\n  Même à 57 ans, il avait des avant-bras \r\n  bien massifs et musclés de près de 42 cm (contractés) si l’on \r\n  se fie aux sources de l’époque.\r\n  Bien que de nombreux athlètes \r\n  aient aujourd’hui oublié l’homme et ses records, il a laissé son \r\n  nom à un des meilleurs exercices pour à la fois matraquer bras \r\n  et avant-bras: le curl Zottman.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 7,
      },
      {
        id: 81,
        name: 'Extensions des poignets aux haltères',
        description: "L'extension des poignets aux haltères est une variante de l'extension des poignets à la barre. Elle permet un mouvement plus naturel, et tout aussi efficace, pour muscler la partie externe des avant-bras. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 7,
      },
    ],
  },
  {
    id: 8,
    name: 'Cuisses',
    created_at: '2022-08-14T21:36:53.000000Z',
    updated_at: null,
    exercises: [
      {
        id: 14,
        name: 'Le soulevé de terre Sumo',
        description: 'C’est assez agaçant quand quelqu’un vient vous dire au milieu d’une \r\n  série éreintante de soulevé de terre : « Tu le fais mal la ! ». \r\n  Mais il faut rester zen, car toute critique est bonne à prendre \r\n  et il faut sans cesse essayer d’améliorer sa technique.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 15,
        name: 'Hack squat',
        description: "Cet exercice de musculation sollicite et développe les muscles des \r\n    cuisses et les fessiers. Si vous avez tendance à tout prendre dans les \r\n\tfessiers, ce mouvement est fait pour vous ! Il fait plus travailler les \r\n\tquadriceps et moins les fessiers. C'est une bonne alternative au\r\n\tsquat à la barre, un exercice certes efficace \r\n\tmais qui ne convient pas à tout le monde.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 16,
        name: 'Leg curl ischios',
        description: 'Cet exercice de musculation sollicite et tonifie l’arrière des \r\n  cuisses. C’est un exercice d’isolation qui est efficace pour ces muscles \r\n  mais moins rentable que les exercices poly articulaires comme le soulevé \r\n  de terre et ses variantes qui vous feront prendre \r\n  plus de masse aux cuisses.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 17,
        name: 'Squat barre',
        description: "Cet exercice de musculation sollicite et développe l’ensemble du corps \r\n  mais vise principalement les muscles des cuisses et les fessiers. C'est \r\n  l'exercice roi de la musculation. « Ceux qui ne font pas de squat, ne \r\n  font pas de musculation » est une expression qu'on entend souvent de la \r\n  bouche des culturistes. Assez technique, il demande un bon équilibre et une \r\n  certaine souplesse. Efficace et rentable, il ne convient pas à toutes les \r\n  morphologies qui tireront plus de bénéfices d'autres exercices.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 18,
        name: 'Presse à cuisses',
        description: "Cet exercice de musculation sollicite les muscles des cuisses et les fessiers. \r\n  Il est considéré comme moins risqué que le squat à la barre \r\n  car la charge est répartie sur l’ensemble du dos grâce au \r\n  dossier de la machine. Il n’est cependant pas impossible de se blesser \r\n  dessus si on pousse n'importe comment. \r\n  De plus, les presses à cuisses sont souvent mal conçues et \r\n  ne correspondent pas à toutes les morphologies ce qui peut \r\n  poser des problèmes.\r\n  En revanche, il est possible de \r\n  reposer la charge à tout moment grâce à des poignets bloquantes sur le \r\n  côté de la machine. On peut donc faire ses séries jusqu’à l’échec \r\n  musculaire ce qui n’est pas possible au squat libre.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 19,
        name: 'Squat une jambe',
        description: "Cet exercice de musculation sollicite les muscles des \r\n  cuisses et les fessiers. Il est très efficace et excellent pour développer la \r\n  coordination et l’équilibre, en plus de faire gagner du muscle aux cuisses et \r\n  fessiers. Il s’exécute de la même façon que le squat mais sur une \r\n  seule jambe.Il convient parfaitement à ceux qui n’ont pas ou \r\n  très peu de matériel, à ceux qui ont des problèmes au dos et qui ne \r\n  peuvent pas faire de squat à la barre. C'est d'ailleurs sur cet exercice que \r\n\tles pratiquants de la méthode Lafay construisent leurs cuisses.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 97,
        name: 'Le Power Clean',
        description: "Comme vous avez pu le constater, je suis toujours à la recherche de nouveaux exercices pour varier un peu Entraînements et \r\n    éviter la routine. Aujourd’hui, nous nous intéressons au Power Clean, une version « bodybuilding » de l'épaulé des haltérophiles.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 98,
        name: 'Leg curl assis',
        description: "Le leg curl assis est sans doute le mouvement qui est le plus efficace lorsqu'il s'agit de travailler les ischio-jambiers. De plus, il est très simple puisqu'il suffit de s’asseoir sur la chaise à leg curl, de caler les jambes entre les deux supports et d'essayer de fléchir les genoux à 90 degrés. Puis, il faut contrôler le poids lorsque les jambes remontent. Les poignées, situées sur le côté de l'appareil, permettent de conserver une bonne stabilité. ",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 99,
        name: 'Les Burpees',
        description: 'Lundi soir, 18 heures. Tous les vélos occupés et plus une place sur \n  les rameurs. Me voila bien embêté ! Comment vais-je donc pouvoir \n  m’échauffer ? Etant actuellement dans la mouvance « \n  Crossfit », pourquoi ne pas des Burpees pour changer !?',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 100,
        name: 'Soulevé de terre roumain',
        description: "Cet exercice de musculation développe tout le corps. Il s'agit ici d'une \r\n  variante du soulevé de terre classique. En tant qu'exercice poly articulaire qui sollicite beaucoup de masse musculaire, \r\n  il vous permettra gagner pas mal de muscle au niveau de la chaîne \r\n  postérieure.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 101,
        name: 'Soulevé de terre jambes tendues',
        description: "Cet exercice de musculation développe tout le corps, particulièrement \r\n  les fessiers, l'arrière des cuisses et les lombaires. C'est un exercice \r\n  technique qui nécessite pas mal de souplesse. \r\n  Le soulevé de terre jambes tendues est un exercice presque identique au soulevé de terre roumain. \r\n  Pour le soulevé de terre jambes tendues, les jambes sont moins \r\n  écartées - d'environ la largeur du bassin - et elles sont presque tendues.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 102,
        name: 'Adducteurs assis à la machine',
        description: 'L’exercice des adducteurs assis à la machine permet de muscler l’intérieur des cuisses. C’est un mouvement d’isolation apprécié des femmes qui cherchent à tonifier et galber leurs jambes. Mais, il intéresse aussi les pratiquants de certaines disciplines comme le football, le ski ou le surf. ',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 103,
        name: 'Sissy squat',
        description: "Cet exercice de musculation sollicite les quadriceps, les muscles situés \r\n  sur le bas de la cuisse. C'est un exercice de finition que vous pouvez \r\n  utiliser en fin de séance. Vous pouvez l’exécuter sur une machine prévue \r\n  pour ou sans, comme sur la démonstration. Il peut remplacer l'exercice \r\n  de leg-extension. Il permet d'accentuer le travail du droit antérieur par un étirement important.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 104,
        name: 'Abducteurs assis à la machine',
        description: 'L’exercice des abducteurs assis à la machine est un mouvement d’isolation qui permet de travailler les abducteurs et le fessier. Ce n’est pas un mouvement indispensable car ces muscles sont déjà fortement sollicités par des exercices basiques \r\n\tcomme le squat ou la presse à cuisses, mais il peut servir de finition pour les personnes qui cherchent à se focaliser sur cette zone anatomique.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 105,
        name: 'Fentes avec haltères',
        description: 'Les fentes avant galbent et musclent les cuisses et les fessiers. Très \r\n  pratiquées en salle de musculation, les fentes ne permettent pas d’utiliser \r\n  de lourdes charges et nécessitent un certain temps d’adaptation pour obtenir un bon équilibre.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 106,
        name: 'Leg extension',
        description: "Cet exercice de musculation sollicite les muscles du bas de la cuisse. \r\n  C'est un exercice d’isolation pour le quadriceps qui termine en général la \r\n  séance de cuisses. Il ne vaut pas le \r\n  squat mais permet de travailler les cuisses sans solliciter \r\n  les fessiers et dos. En revanche, il impose un grand stress au niveau du \r\n  genou et ne peut donc pas convenir aux personnes ayant des problèmes au niveau \r\n  de cette articulation.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 107,
        name: 'Front squat barre',
        description: 'Le front squat barre ou squat avant est une variante du mouvement de squat classique. Pendant cet exercice, la barre est posée sur l’avant des deltoïdes et non au niveau des trapèzes. Le front squat a l’avantage de mieux cibler les quadriceps (partie basse du muscle) et il permet d’utiliser une charge plus faible, ce qui peut soulager les lombaires. De plus, il est moins dangereux pour les genoux. Cependant, le maintien de la barre peut être plus difficile et elle a tendance à vous tirer vers l’avant.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 108,
        name: 'Soulevé de terre',
        description: "Cet exercice de musculation de base développe tout le corps et permet de gagner \r\n  beaucoup de force. Rien ne vaut le soulevé de terre ou « \r\n  Deadlift » pour prendre de la masse, à part peut être le \r\n  squat ! Il \r\n  travaille les quadriceps, les arrière cuisses, les fessiers, le dos, les \r\n  mollets, les abdos, les lombaires, les trapèzes et même les avant-bras. \r\n  Pour certains, il est indispensable si l'on veut se forger un physique solide et massif \r\n  ; pour d'autres, il est trop risqué et remplaçable par d’autres exercices. \r\n  Le soulevé de terre déchaîne les passions, et tout le monde a un avis sur la \r\n  question.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
      {
        id: 109,
        name: 'Jump squat poids du corps',
        description: "Le Jump squat, comme son nom l'indique, est un exercice qui mélange \r\n\tle squat à un saut vertical. C'est un exercice intéressant pour travailler les jambes et développer l'explosivité, la détente et la vitesse, mais aussi l'équilibre et la mobilité. C'est aussi un exercice qui peut améliorer les capacités cardio-vasculaires car il demande beaucoup de ressources.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 8,
      },
    ],
  },
  {
    id: 9,
    name: 'Mollets',
    created_at: '2022-08-14T21:36:53.000000Z',
    updated_at: null,
    exercises: [
      {
        id: 32,
        name: 'Mollets au donkey',
        description: "Cet exercice de musculation sollicite les mollets, jumeaux et \r\n  soléaire. Il est peu pratiqué en salle faute de machine spécifique ou de \r\n  partenaire audacieux.  En effet, il est difficile de trouver un ou une \r\n  partenaire qui accepte de vous monter dessus ! Il donne néanmoins de bonnes sensations \r\n  sur les jumeaux. On peut le remplacer par l'exercice de mollets à la presse à \r\n  cuisses.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 9,
      },
      {
        id: 43,
        name: 'Mollets assis',
        description: "Cet exercice de musculation sollicite le soléaire, un muscle puissant de la \r\n  jambe qui permet l'extension du pied. Les muscles soléaires, très \r\n  résistants, sont essentiellement constitués de fibres lentes. Il faudra donc travailler en séries plutôt longues. Il est préférable de \r\n  commencer sa séance de mollets par les exercices de musculation ou les jambes \r\n  sont tendues comme les mollets debout, et finir par les \r\n  exercices assis.",
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 9,
      },
      {
        id: 66,
        name: 'Mollets à la presse à cuisses',
        description: 'Cet exercice de musculation sollicite les mollets, jumeaux et \r\n  soléaire. Les sensations musculaires sont très différentes du fait de la \r\n  position sur la machine. La presse à cuisse est très sécuritaire et utile pour les personnes qui ont \r\n  des problèmes de dos et qui ne peuvent pas pratiquer les exercices où \r\n  une charge écrase la colonne vertébrale comme aux mollets debout.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 9,
      },
      {
        id: 78,
        name: 'Mollets debout',
        description: 'Cet exercice de musculation renforce et développe les mollets, plus \r\n  particulièrement les jumeaux tout au-dessus, du fait de la position james \r\n  tendues. Les jumeaux \r\n  sont constitués de fibres lentes et de fibres rapides, il faudra donc \r\n  les travailler en séries longues et courtes. Il est préférable de \r\n  commencer sa séance de mollets par les exercices de musculation comme \r\n  les mollets debout et de finir par les exercices assis.',
        created_at: '2022-08-14T21:36:53.000000Z',
        updated_at: null,
        laravel_through_key: 9,
      },
    ],
  },
];

export default exercisesList;
